import * as React from 'react';
import { Actions } from '@src/context/actions/actions';
import { PrivacyPolicyType, ISitePage, AppSettings, TranslationsMap, TranslationKey } from '@src/types';
import { InjectedTranslateProps, translate } from 'react-i18next';
import {
  Container,
  Row,
  Col,
  Card,
  FloatingNotification,
  FormField,
  RadioGroup,
  InfoIcon,
  Text,
  Divider,
  Box,
  Layout,
  Cell,
} from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { InfoCircle } from 'wix-ui-icons-common';
import { PolicyTypeInput } from './privacy-policy-input';

type MappedActions = Pick<Actions, 'updatePendingAppSettings'>;
type MappedProps = MappedActions & {
  privacyPolicyType: PrivacyPolicyType;
  notificationKBLink: string;
};

export interface Props extends InjectedTranslateProps, MappedProps {}

class PrivacyPolicyComponent extends React.PureComponent<Props> {
  onUpdateSetting = (updatedSetting: Partial<AppSettings>) => this.props.updatePendingAppSettings(updatedSetting);
  onChangeType = (privacyPolicyType: PrivacyPolicyType) => this.onUpdateSetting({ privacyPolicyType });

  render() {
    const { t, privacyPolicyType, notificationKBLink } = this.props;
    const renderRecommendationNotification = () => (
      <FloatingNotification
        text={t('privacy-policy.recommendation')}
        prefixIcon={<InfoCircle />}
        type="warning"
        showCloseButton={false}
        width="100%"
        textButtonProps={{
          as: 'a',
          href: notificationKBLink,
          target: '_blank',
          label: t('privacy-policy.recommendation.learn-more'),
        }}
      />
    );

    const renderPolicyTypeSelection = () => (
      <RadioGroup dataHook={DataHooks.PrivacyPolicyType} value={privacyPolicyType} onChange={this.onChangeType as any}>
        <RadioGroup.Radio value={PrivacyPolicyType.PageOnSite}>
          <Text style={{ paddingRight: '6px' }}>{t('privacy-policy.location.page-on-site.title')}</Text>
          <InfoIcon content={t('privacy-policy.location.page-on-site.tooltip')} />
        </RadioGroup.Radio>
        <RadioGroup.Radio value={PrivacyPolicyType.ExternalUrl}>
          <Text style={{ paddingRight: '6px' }}>{t('privacy-policy.location.external-url.title')}</Text>
          <InfoIcon content={t('privacy-policy.location.external-url.tooltip')} />
        </RadioGroup.Radio>
      </RadioGroup>
    );

    return (
      <Container>
        <Row>
          <Col>
            <Card dataHook={DataHooks.PrivacyPolicyContainer}>
              <Card.Header
                dataHook={DataHooks.PrivacyPolicyHeader}
                title={t('privacy-policy.title')}
                subtitle={t('privacy-policy.subtitle')}
              />
              <Card.Divider />
              <Card.Content>
                <Container fluid>
                  <Row>
                    <Col>
                      <Container fluid>
                        <Row>
                          <Col>{renderRecommendationNotification()}</Col>
                        </Row>
                        <Row>
                          <Col>
                            <FormField label={t('privacy-policy.location.title')}>
                              <Box>
                                {renderPolicyTypeSelection()}
                                <Box padding="0 30px">
                                  <Divider direction="vertical" />
                                </Box>
                                <Box width="370px">
                                  <Layout cols={1}>
                                    <Cell>
                                      <PolicyTypeInput />
                                    </Cell>
                                  </Layout>
                                </Box>
                              </Box>
                            </FormField>
                          </Col>
                        </Row>
                      </Container>
                    </Col>
                  </Row>
                </Container>
              </Card.Content>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export const PrivacyPolicyCard = translate()(PrivacyPolicyComponent);
